import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

const root = createRoot(document.getElementById("root")!);

root.render(<App />);

// Load Vercel Analytics only in production on the canonical hostname
if (import.meta.env.PROD && typeof window !== "undefined" && window.location.hostname === "www.newbusiness.com.sa") {
  import('@vercel/analytics/react').then(({ Analytics }) => {
    try {
      const container = document.createElement('div');
      container.id = '__vercel_analytics';
      document.body.appendChild(container);
      createRoot(container).render(<Analytics />);
    } catch (e) {
      // fail silently in case analytics cannot be mounted
      console.warn('Vercel Analytics mount failed', e);
    }
  }).catch(() => {
    // ignore import failures (adblockers or network issues)
  });
}
